import React from "react";
import { motion } from "framer-motion";
import { PROCESS_STEPS } from "../../data/content";

export const Process = () => {
  return (
    <section
      id="process"
      className="scroll-mt-20 py-16 md:py-24 bg-white/[0.02] border-y border-white/5"
      data-testid="process-section"
    >
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.3 }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl"
        >
          <p className="text-sm font-medium text-primary tracking-wide uppercase">How It Works</p>
          <h2 className="font-display text-3xl md:text-4xl font-semibold tracking-tight text-foreground mt-3">
            You describe it. We build it.
          </h2>
          <p className="text-muted-foreground mt-4 leading-relaxed">
            Any business, any industry — warehouses, clinics, shops, sellers. Just tell us
            what your business does and what you need. We handle the rest.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-12">
          {PROCESS_STEPS.map((step, i) => (
            <motion.div
              key={step.step}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.25 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="glass-card glass-card-hover p-6 relative overflow-hidden"
              data-testid={`process-step-${i + 1}`}
            >
              <span className="font-display text-5xl font-bold text-white/5 absolute top-3 right-4 select-none">
                {step.step}
              </span>
              <div className="h-1.5 w-10 rounded-full bg-primary mb-5" />
              <h3 className="font-display text-lg font-semibold text-foreground">{step.title}</h3>
              <p className="text-sm text-muted-foreground mt-2.5 leading-relaxed">{step.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
